import { useMutation, useQueryClient } from 'react-query'

import { ACCOUNTS_QUERY_KEY } from 'features/accounts/constants'
import type {
  AccountsService,
  CreateAccountInput,
} from 'features/accounts/service'
import type { Account } from 'features/accounts/types'

type UseCreateAccountResult = {
  createAccount: (input: CreateAccountInput) => Promise<Account>
  isCreating: boolean
}

export function useCreateAccount(
  service: AccountsService,
): UseCreateAccountResult {
  const queryClient = useQueryClient()
  const mutation = useMutation<Account, Error, CreateAccountInput>(
    (input) => service.createAccount(input),
    {
      onSuccess: () => {
        void queryClient.invalidateQueries([ACCOUNTS_QUERY_KEY])
      },
    },
  )
  return {
    createAccount: (input) => mutation.mutateAsync(input),
    isCreating: mutation.isLoading,
  }
}
